<template>
  <tab-layout :actionBar="true">
    <draft-add-details :details="resolvedDetails" :edit="resolvedEdit" slot="tabContent" class="row mx-0 show active" />
  </tab-layout>
</template>

<script>
/* Use the "slot" attribute to match the heading and content
 * to their respective fields in the ListingLayout component. */
import tabLayout from '@/components/TabLayout'
import draftAddDetails from './EventAddDetails'

export default {
  name: 'EventCreate',
  props: ['details', 'edit', 'eventId', 'draftId'],
  components: {
    'tab-layout': tabLayout,
    'draft-add-details': draftAddDetails
  },
  computed: {
    // When this page is opened directly from a URL (e.g. a new tab), `details`/`edit`
    // never arrive as route params — only the path segments (`draftId`/`eventId`) do.
    // Fall back to a minimal details object so EventAddDetails fetches the rest itself.
    resolvedEdit() {
      return this.edit || !!this.eventId
    },
    resolvedDetails() {
      if (this.details) return this.details
      if (this.eventId) return { id: this.eventId, draft_id: this.draftId }
      // Create mode opened straight from a URL (Add Event in a new tab): EventAddDetails only
      // needs `details` truthy with `.id` = the parent draft id (it redirects back to the
      // events list when `details` is falsy).
      if (this.draftId) return { id: this.draftId }
      return null
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Drafts/Events/Add/EventAdd.vue